import styled from "styled-components";

export const Container = styled.div`
  width: 200px;

  padding: 30px;
  border: 1px solid black;
  border-radius: 10px;
  font-size: 20px;
  background-color: rgb(255, 255, 255, 0.5);
  margin: 0px 0px 5px 0px;
`;
